import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
import { globalStore } from "../stores/global";
import VideoPlayer from './video-player';
import './video-marquee-meet.scss';
import useStream from '../hooks/use-streams';
import { AgoraMediaStream } from '../utils/types';


import styles from './video-marquee-meet.module.scss'
import { useLocation } from 'react-router-dom'
import MediaBoard from './mediaboard';
const Carousel = require('react-grid-carousel');



const ControlBtnGroup = (props: any) => {
  return (
    <div className={styles.controlBar}>
      <div className={styles.leftBtn} onClick={props.handleLeftBtnClick}>
        <span className={styles.leftArrow}></span>
      </div>
      <div className={styles.rightBtn} onClick={props.handleRightBtnClick}>
        <span className={styles.rightArrow}></span>
      </div>
    </div>
  )
}


const showScrollbar = () => {
  const $marquee = document.querySelector(".video-marquee .agora-video-view");
  if ($marquee) {
    const clientWidth = $marquee.clientWidth;
    const marqueeLength: number = document.querySelectorAll(".video-marquee .agora-video-view").length;
    const videoMarqueeMark = document.querySelector('.video-marquee-mask')
    if (clientWidth && videoMarqueeMark) {
      const videoMarqueeWidth = videoMarqueeMark.clientWidth;
      const width: number = clientWidth * marqueeLength;
      // console.log("[video-marquee] videoMarqueeWidth: ", videoMarqueeWidth, ", width: ", width);
      if (videoMarqueeWidth <= width) {
        return true;
      }
    }
  }
  return false;
}


function VideoMarqueeMeet() {

  const { teacher, students, onPlayerClick } = useStream();

  const marqueeEl = useRef(null);

  const scrollLeft = (current: any, offset: number) => {
    current.scrollLeft += (offset * current.childNodes[1].offsetWidth);
  }

  const handleScrollLeft = (evt: any) => {
    scrollLeft(marqueeEl.current, 1);
  }

  const handleScrollRight = (evt: any) => {
    scrollLeft(marqueeEl.current, -1);
  }

  const ref = useRef<boolean>(false);

  useEffect(() => {
    return () => {
      ref.current = true;
    }
  }, []);

  const [scrollBar, setScrollBar] = useState<boolean>(false);
  const [userStreamID, setUserStreamID] = useState<number>(0);
  const [userType, setUserType] = useState('student');


  useLayoutEffect(() => {
    if (!students.length) return;
    !ref.current && setScrollBar(showScrollbar());
  }, [students]);

  useEffect(() => {
    window.addEventListener('resize', (evt: any) => {
      !ref.current && setScrollBar(showScrollbar());
    });
    return () => {
      window.removeEventListener('resize', () => { });
    }
  }, []);


  // const { videoZoomIn } = useGlobalState();

  // agora meet 
  const location = useLocation()

  const itemsRef = useRef<any>(null)

  const offsetXWidth = useRef<number>(0)


  // TODO: need remove
  //@ts-ignore
  window.bar = itemsRef

  useEffect(() => {
    return () => {
      itemsRef.current = null;
    }
  }, [])
  const users = []
  if (teacher) {
    teacher.role = 'teacher'
    users.push(teacher)
  }
  students.map(item => {
    item.role = 'teacher'
    users.push(item)
  })

  return (
    <div className={styles.lectorLobbyLayout}>
      <div className={styles.mainLectorView}>
        {globalStore.state.videoZoomIn
          ? <div className="flex">
            {/* {teacher ?
              <div className={`thumbnail dimintion${users.length} oddIndex`}>
                <div className="cropper" onClick={(e) => {
                  setUserStreamID(teacher.streamID);
                  setUserType('teacher')
                  globalStore.setVideoListZoomIn(true);
                }}>
                  <VideoPlayer
                    role="teacher"
                    domId={`dom-${teacher.streamID}`}
                    id={`${teacher.streamID}`}
                    streamID={teacher.streamID}
                    stream={teacher.stream}
                    account={teacher.account}
                    audio={Boolean(teacher.audio)}
                    video={Boolean(teacher.video)}
                    local={Boolean(teacher.local)}
                    handleClick={onPlayerClick}
                  />
                </div>
              </div>
              : null} */}

            {users.map((user, key: number) => {
              return <div className={`thumbnail dimintion${users.length} odd${teacher ? key + 2 : key + 1}`}>
                <div className="cropper" onClick={(e) => {
                  setUserStreamID(user.streamID);
                  setUserType(user.role)
                  globalStore.setVideoListZoomIn(true);
                }}>
                  <VideoPlayer
                    role={user.role}
                    domId={`dom-${user.streamID}`}
                    key={`${key}${user.streamID}`}
                    id={`${user.streamID}`}
                    account={user.account}
                    streamID={user.streamID}
                    stream={user.stream}
                    video={user.video}
                    audio={user.audio}
                    local={user.local}
                    handleClick={onPlayerClick}
                  />
                </div>
              </div>
            })}
          </div>
          : <div className={`row`}>
            <div className={users.length > 1 ? 'col-8' : 'col-12'}>
              <div className={`zoomIn--video`} onClick={(e) => { globalStore.setVideoListZoomIn(true); }}>
                {/* {teacher && teacher.streamID == userStreamID
                  ? <VideoPlayer
                    role="teacher"
                    domId={`dom-${teacher.streamID}`}
                    id={`${teacher.streamID}`}
                    streamID={teacher.streamID}
                    stream={teacher.stream}
                    account={teacher.account}
                    audio={Boolean(teacher.audio)}
                    video={Boolean(teacher.video)}
                    local={Boolean(teacher.local)}
                    handleClick={onPlayerClick}
                  />
                  : null} */}
                {users.map((user, key: number) => (
                  user.streamID == userStreamID
                    ? (
                      <VideoPlayer
                        role={user.role}
                        domId={`dom-${user.streamID}`}
                        key={`${key}${user.streamID}`}
                        id={`${user.streamID}`}
                        account={user.account}
                        streamID={user.streamID}
                        stream={user.stream}
                        video={user.video}
                        audio={user.audio}
                        local={user.local}
                        handleClick={onPlayerClick}
                      />
                    ) : null))}
              </div>
            </div>
            <div className={`col-4`}>
              <Carousel cols={1} rows={3} scrollSnap={true} gap={10} hideArrow={true} showDots={true} dotColorActive={`#606060`} dotColorInactive={`#1c1c1c`}>
                {userType != 'teacher' ?
                  <Carousel.Item>
                    <div className={`content--div--col1`}
                      onClick={(e) => {
                        setUserStreamID(teacher.streamID);
                        setUserType('teacher');
                        globalStore.setVideoListZoomIn(false);
                      }}>
                      <VideoPlayer
                        role="teacher"
                        domId={`dom-${teacher.streamID}`}
                        id={`${teacher.streamID}`}
                        streamID={teacher.streamID}
                        stream={teacher.stream}
                        account={teacher.account}
                        audio={Boolean(teacher.audio)}
                        video={Boolean(teacher.video)}
                        local={Boolean(teacher.local)}
                        handleClick={onPlayerClick}
                      />
                    </div>
                  </Carousel.Item>
                  : null}
                {users.map((user, key: number) => (
                  user.streamID != userStreamID ? (
                    <Carousel.Item>
                      <div className={`content--div--col1`}
                        onClick={(e) => {
                          setUserStreamID(user.streamID);
                          setUserType(user.role);
                          globalStore.setVideoListZoomIn(false);
                        }}>
                        <VideoPlayer
                          role={user.role}
                          domId={`dom-${user.streamID}`}
                          key={`${key}${user.streamID}`}
                          id={`${user.streamID}`}
                          account={user.account}
                          streamID={user.streamID}
                          stream={user.stream}
                          video={user.video}
                          audio={user.audio}
                          local={user.local}
                          handleClick={onPlayerClick}
                        />
                      </div>
                    </Carousel.Item>
                  ) : null
                ))}
              </Carousel>
            </div>
          </div>
        }
      </div>
    </div >
  )
}
export default React.memo(VideoMarqueeMeet);